import { render, staticRenderFns } from "./signup.vue?vue&type=template&id=7953723e&scoped=true"
import script from "./signup.vue?vue&type=script&lang=ts"
export * from "./signup.vue?vue&type=script&lang=ts"
import style0 from "./signup.vue?vue&type=style&index=0&id=7953723e&prod&lang=scss"
import style1 from "./signup.vue?vue&type=style&index=1&id=7953723e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7953723e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OtpInput: require('/usr/src/app/components/OtpInput.vue').default})
